import type { GlobalSearchResultItem } from 'models';
import { Avatar, Text } from 'ui';
import { SearchItemRow } from '../search-item-row';

type P = {
  itemActionProps?: Record<string, unknown>;
  itemProps: GlobalSearchResultItem;
};

const UserItem = ({ itemActionProps, itemProps }: P) => {
  const fullName = `${itemProps.firstName ?? ''} ${itemProps.lastName ?? ''}`.trim();

  return (
    <SearchItemRow
      icon={<Avatar alt={fullName} size="lg" src={itemProps.profilePhoto} />}
      itemActionProps={itemActionProps}
    >
      <Text size="medium" weight="medium">
        {fullName}
      </Text>
    </SearchItemRow>
  );
};

export default UserItem;
